import { COLORS } from "../../shared/constants";
import { IconEdit } from "../../shared/icons";
import { useState } from "react";
import * as api from "../../api";

export default // ─── Lookup Table Tab (Coils, Treatment Spots, MT Spots) ─────
function LookupTab({ title, items, category, onRefresh }) {
  const [newName, setNewName] = useState("");
  const [editing, setEditing] = useState(null);
  const [editName, setEditName] = useState("");
  const [saving, setSaving] = useState(false);

  const handleAdd = async () => {
    if (!newName.trim() || saving) return;
    setSaving(true);
    try {
      await api.createSetting(category, { name: newName.trim() });
      const res = await api.getSettings(category);
      onRefresh(res.items || []);
      setNewName("");
    } catch (e) { console.error("Add item:", e); }
    setSaving(false);
  };
  const handleToggle = async (id) => {
    const item = items.find((i) => i.id === id);
    if (!item) return;
    try {
      await api.updateSetting(category, id, { is_active: !item.is_active });
      const res = await api.getSettings(category);
      onRefresh(res.items || []);
    } catch (e) { console.error("Toggle item:", e); }
  };
  const handleRename = async (id) => {
    if (!editName.trim()) return;
    try {
      await api.updateSetting(category, id, { name: editName.trim() });
      const res = await api.getSettings(category);
      onRefresh(res.items || []);
    } catch (e) { console.error("Rename item:", e); }
    setEditing(null);
  };

  const active = items.filter((i) => i.is_active);
  const inactive = items.filter((i) => !i.is_active);

  return (
    <div>
      <h3 style={{ fontSize: "16px", fontWeight: "600", color: COLORS.text, marginBottom: "16px" }}>{title}</h3>
      <div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
        <input style={{ flex: 1, height: "40px", padding: "0 12px", borderRadius: "8px", border: `1px solid ${COLORS.border}`, background: COLORS.inputBg, fontSize: "14px", outline: "none" }}
          value={newName} onChange={(e) => setNewName(e.target.value)} placeholder={`Add new ${title.toLowerCase().replace(/s$/, "")}…`}
          onKeyDown={(e) => e.key === "Enter" && handleAdd()} />
        <button onClick={handleAdd} style={{ height: "40px", padding: "0 16px", borderRadius: "8px", border: "none", background: COLORS.accent, color: "#FFF", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>Add</button>
      </div>
      {active.map((item) => (
        <div key={item.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 12px", borderBottom: `1px solid ${COLORS.borderLight}` }}>
          {editing === item.id ? (
            <div style={{ display: "flex", gap: "6px", flex: 1 }}>
              <input style={{ flex: 1, height: "32px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, fontSize: "13px" }}
                value={editName} onChange={(e) => setEditName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleRename(item.id)} autoFocus />
              <button onClick={() => handleRename(item.id)} style={{ height: "32px", padding: "0 10px", borderRadius: "6px", border: "none", background: COLORS.primary, color: "#FFF", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>Save</button>
              <button onClick={() => setEditing(null)} style={{ height: "32px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: "transparent", fontSize: "11px", cursor: "pointer", color: COLORS.textSecondary }}>Cancel</button>
            </div>
          ) : (
            <>
              <span style={{ fontSize: "14px", color: COLORS.text }}>{item.name}</span>
              <div style={{ display: "flex", gap: "4px" }}>
                <button onClick={() => { setEditing(item.id); setEditName(item.name); }} style={{ height: "28px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: COLORS.surface, color: COLORS.primary, fontSize: "11px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "3px" }}><IconEdit /></button>
                <button onClick={() => handleToggle(item.id)} style={{ height: "28px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.dangerBorder}`, background: COLORS.dangerLight, color: COLORS.danger, fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>Deactivate</button>
              </div>
            </>
          )}
        </div>
      ))}
      {inactive.length > 0 && (
        <div style={{ marginTop: "16px" }}>
          <div style={{ fontSize: "12px", fontWeight: "600", color: COLORS.textSecondary, marginBottom: "8px" }}>Deactivated</div>
          {inactive.map((item) => (
            <div key={item.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", background: COLORS.inputBg, borderRadius: "6px", marginBottom: "4px" }}>
              <span style={{ fontSize: "13px", color: COLORS.textSecondary, textDecoration: "line-through" }}>{item.name}</span>
              <button onClick={() => handleToggle(item.id)} style={{ height: "26px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: COLORS.surface, color: COLORS.accent, fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>Reactivate</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Diagnoses Tab ────────────────────────────────

